import { Record, Map as ImmutableMap } from 'immutable';
// @ts-expect-error untyped dependency
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import { FORM } from 'FormsUI/constants/FormPreviewSteps';
export const FormPreviewKeys = {
  PREFILLED_FIELDS: 'prefilledFields',
  REQUEST_STATE: 'requestState',
  PREVIEW_CONTACT: 'previewContact',
  PAGE_STEP: 'pageStep'
};
export default class FormPreview extends Record({
  [FormPreviewKeys.PREFILLED_FIELDS]: ImmutableMap(),
  [FormPreviewKeys.REQUEST_STATE]: RequestState.NOT_REQUESTED,
  [FormPreviewKeys.PREVIEW_CONTACT]: null,
  [FormPreviewKeys.PAGE_STEP]: FORM
}) {}